import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'dynamic-form-builder',
  templateUrl: './dynamic-form-builder.component.html',
})
export class DynamicFormBuilderComponent implements OnInit {
  @Output() onSubmit = new EventEmitter();
  @Input() fields: any[] = [];
  @Input() rowData: any[] = [];
  result:any[] = [];
  form: FormGroup;
  obj;
  rId;
  constructor(private modal: NgbModal) { }

  ngOnInit() {
    let fieldsCtrls = {};
    for (let f of this.fields) {
      if (f.type != 'checkbox') {
        fieldsCtrls[f.name] = new FormControl(f.value || '', Validators.required)
      } else {
        let opts = {};
        for (let opt of f.options) {
          opts[opt.key] = new FormControl(opt.value);
        }
        fieldsCtrls[f.name] = new FormGroup(opts)
      }
    }
    this.form = new FormGroup(fieldsCtrls);
if(this.rowData!=null && this.rowData.length > 0){
  this.rId=this.rowData[0].rowId;
  this.obj={};
  for(let item of this.rowData){
    if(this.rId===item["rowId"]){
      this.obj[item["key"]]=item.value;
    }else{
      this.result.push(this.obj);
      this.obj={};
      this.obj[item["key"]]=item.value;
      this.rId=item["rowId"];
    }
    
  }
  this.result.push(this.obj);
}

  }
  addMySpaceModal(addMySpace) {
    this.modal.open(addMySpace, { size: 'lg', container: '.page-content' });
  }
}
